import { useNavigate } from 'react-router-dom';
import React from "react";
const Header = React.lazy(() => import(`./header.js?v=${process.env.REACT_APP_VERSION}`));
const SocialMarketAnalyticsWidget = React.lazy(() => import(`./ssfWidget.js?v=${process.env.REACT_APP_VERSION}`));
const Footer = React.lazy(() => import(`./footer.js?v=${process.env.REACT_APP_VERSION}`));

// import Header from './header';
// import SocialMarketAnalyticsWidget from './ssfWidget';
// import Footer from "./footer";



const Dashboard = (props) => {
    const { loggedIn, email } = props;
    const navigate = useNavigate();
    // const user_package_list = JSON.parse(sessionStorage.getItem('user_package_list'));
    // const user_package_list = JSON.parse(sessionStorage.getItem('user_package_list') || 'null');


// <<<<<<< HEAD

    // const filteredProducts = user_package_list.filter(
    //     (product) => product.product_name === "riskdesktop"
    //     // (product) => product.product_name === "riskdesktop"
    // );


    // Safely get and parse 'user_package_list' with a fallback for undefined/null
    const user_packagelist = JSON.parse(sessionStorage.getItem('user_package_list')) || '[]';

// Add optional chaining and null check before filtering
//     const filteredProducts = user_packagelist?.filter(
//         (product) => product?.product_name === "riskdesktop"
//     ) || [];

    // const filteredProducts = "riskdesktop";
    // console.log('wwwwwwwwwwwwww');
    // console.log(filteredProducts);


// =======
    // const filteredProducts = user_package_list.filter(
    //     (product) => product.product_name === "riskdesktop"
        // (product) => product.product_name === "riskdesktop"
    // );
    const filteredProducts = "riskdesktop";
    // console.log('wwwwwwwwwwwwww');
    // console.log(filteredProducts);

    return (
        <div>

            <Header />

            {filteredProducts && filteredProducts.length > 0 ?
                <>
                    <SocialMarketAnalyticsWidget />
                    <Footer />
                </>
                :
                (
                    <div style={{
                        color: 'white',
                        backgroundColor: 'red',
                        padding: '10px',
                        borderRadius: '5px',
                        textAlign: 'center',
                        fontWeight: 800,
                        fontSize: 'larger',
                    }}>
                        Access Denied: Risk Desktop permission required.
                    </div>

                )
            }

        </div>
    );
};

export default Dashboard;
